// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
// import todo from '@src/views/apps/todo/store'
import chat from '@src/views/apps/chat/store'
import email from '@src/views/apps/email/store'
//import users from '@src/views/apps/user/store'
//import invoice from '@src/views/apps/invoice/store'
//import ecommerce from '@src/views/apps/ecommerce/store'
//import dataTables from '@src/views/tables/data-tables/store'
//import permissions from '@src/views/apps/roles-permissions/store'


// **-* DIRIGO CUSTOM STORE FILES */
//ORIGINAL TIMELINE CALENDAR
import calendar from '@src/views/DirigoViews/HRManagement/Time&Attendance/TimelineTab/store'
//ORGANIZATION UNIT TIMELINE CALENDAR
import organizationUnitCalendar from '@src/views/DirigoViews/HRManagement/Time&Attendance/OrgUnitTimelineTab/OrgUnitCalendar/store'


// TASKS CALENDAR
import tasksCalendar from '@src/views/DirigoViews/#Tasks/CalendarTab/store'
// TASKS KANBAN
import tasksKanban from '@src/views/DirigoViews/#Tasks/KanbanTab/store'


const rootReducer = {
  auth,
  //todo,
  chat,
  email,
  navbar,
  layout, 
  calendar,
  organizationUnitCalendar,
  tasksCalendar,
  tasksKanban
  //users,
  //invoice,
  //ecommerce,
  //dataTables,
  //permissions
}

export default rootReducer
